var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page-content', {
    attrs: {
      "title": "Konsultasi Psikologi",
      "with-margin": false
    }
  }, [_c('vue-tabs', [_c('v-tab', {
    attrs: {
      "title": "Menunggu"
    }
  }, [_c('mental-health-participant-list', {
    attrs: {
      "data": _vm.unscheduleds,
      "search-placeholder": "Cari nama atau keluhan...",
      "show-name": ""
    },
    on: {
      "item-click": _vm.openCheckupDetail
    }
  })], 1), _c('v-tab', {
    attrs: {
      "title": "Terjadwal"
    }
  }, [_c('mental-health-participant-list', {
    attrs: {
      "data": _vm.scheduleds,
      "search-placeholder": "Cari nama atau keluhan...",
      "show-name": ""
    },
    on: {
      "item-click": _vm.openCheckupDetail
    }
  })], 1), _c('v-tab', {
    attrs: {
      "title": "Selesai"
    }
  }, [_c('mental-health-participant-list', {
    attrs: {
      "data": _vm.completeds,
      "search-placeholder": "Cari nama atau keluhan...",
      "show-name": ""
    },
    on: {
      "item-click": _vm.openCheckupDetail
    }
  })], 1), _c('v-tab', {
    attrs: {
      "title": "Batal"
    }
  }, [_c('mental-health-participant-list', {
    attrs: {
      "data": _vm.canceleds,
      "search-placeholder": "Cari nama atau keluhan...",
      "show-name": ""
    },
    on: {
      "item-click": _vm.openCheckupDetail
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }